<ngb-toast #toast [autohide]="false" [animation]="true" class="w-100">
  <div ngbToastHeader>
    <div class="row g-2 justify-items-center align-items-center mb-2">
      <div class="col-auto icon">
        <div
          class="d-inline-block"
          [@swing]="swingBell"
          [innerHTML]="preparedIcons['new update']"
        ></div>
      </div>
      <div class="col ps-2">
        <h5 [innerHTML]="preparedI18n['new update'].header"></h5>
      </div>
      <div class="col-auto align-items-start" (click)="close()">
        <i class="fa-solid fa-xmark" style="font-size: 1.2rem"></i>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-12" [innerHTML]="preparedI18n['new update'].body"></div>
    <div class="col-12 text-end">
      <button
        class="btn btn-outline-secondary btn-sm mt-3 me-2"
        (click)="close()"
      >
        {{ preparedI18n['later'] }}
      </button>
      <button
        class="btn btn-primary btn-sm mt-3"
        (click)="versionCheckerService.applyUpdate()"
      >
        <span [innerHTML]="preparedIcons.reload"></span>
        {{ preparedI18n['reload now'] }}
      </button>
    </div>
  </div>
</ngb-toast>
